<template>
  <a href="#" @click.prevent="selectItem" class="store-item" v-if="item">
    <div class="store-item__info">
      <div class="store-item__info-name">{{ item.name }}</div>
      <div class="store-item__info-desc">{{ item.description }}</div>
    </div>
    <div class="store-item__action">
      <div class="store-item__price">$ {{ parseInt(item.price) }}</div>
      <div class="store-item__link">
        <span>{{ $t('choose') }}</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'BDTLStoreItem',
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      count: 0,
      amount: 0
    }
  },
  computed: {
    packagePrice () {
      return parseInt(this.item.price)
    }
  },
  methods: {
    selectItem () {
      this.$emit('selectOffer', { id: this.item.id, packageId: this.item.packageId, price: this.packagePrice })
    }
  }
}
</script>

<style lang="scss" scoped>
.store-item {
  width: 220px;
  height: 320px;
  overflow: hidden;
  border-radius: 24px;
  position: relative;
  user-select: none;
  margin: 0 10px 20px;
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: url('../assets/img/packages/card-bg.png') center center no-repeat;
    background-size: cover;
    z-index: -1;
  }
  &__info {
    width: 100%;
    margin-top: 20px;
    padding: 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    &-name {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 15px;
      color: $white;
      text-align: center;
    }
    &-desc {
      font-size: 12px;
      line-height: 1.4;
      color: $white;
      margin-bottom: 20px;
      text-align: center;
      max-height: 235px;
      overflow: hidden;
    }
    &-price {
      font-weight: bold;
      color: $white;
    }
  }
  &__action {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    z-index: 2;
    span{
      display: block;
      font-weight: 500;
      font-size: 12px;
      line-height: 1;
      color: #ffffff;
      -webkit-box-shadow: 0 0 0 rgb(204 169 44 / 40%);
      box-shadow: 0 0 0 rgb(204 169 44 / 40%);
      -webkit-animation: pulseWhite 2s infinite;
      animation: pulseWhite 2s infinite;
      background: transparent;
      border-radius: 12px;
      padding: 5px 12px;
    }
  }
  &__link {
    position: absolute;
    right: 20px;
    bottom: 10px;
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #00b764, green);
    background-size: 400% 400%;
    -webkit-animation: gradient 8s ease infinite;
    animation: gradient 8s ease infinite;
    border-radius: 12px;
  }
  &__price {
    position: absolute;
    left: 40px;
    bottom: 20px;
    color: $white;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.1;
    user-select: none;
  }
}
</style>
